module.exports = __webpack_public_path__ + "static/media/Logo.9932c735.svg";